module.exports = {"320303001":"彭城街道","320303002":"子房街道","320303003":"黄山街道","320303004":"骆驼山街道","320303005":"大郭庄街道","320303006":"翠屏山街道","320303007":"大龙湖街道","320303008":"潘塘街道","320303400":"淮海食品城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320303.json
// module id = 785
// module chunks = 0